import { TprmRequirementDefinition } from '@evidentid/tprm-portal-lib/models/common';
import { SubmissionMethod } from '@evidentid/tprm-portal-lib/models/common/SubmissionMethod.model';

export function isFieldImportApiOrWithoutDocumentUpload({
    submissionMethod,
    requirementDefinition,
}: {
    submissionMethod?: SubmissionMethod;
    requirementDefinition?: TprmRequirementDefinition | null;
}): boolean {
    return submissionMethod === SubmissionMethod.FieldImportApi || requirementDefinition?.hasDocuments === false;
}
